// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a8d7457","455":"1902c049"}[chunkId] + ".chunk.js";
};